import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false, name: 'removeExt' })
export class RemoveFileExtensionPipe implements PipeTransform {
  transform(item) {
    const index = item.lastIndexOf('.');
    return index >= 0 ? item.substring(0, index) : item;
  }
}
